module.exports = __webpack_public_path__ + "static/media/29BDOS19.06f7a1e1.jpg";